import { combineReducers } from 'redux'
import createReducer from 'lib/reducers/createReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { requestedProductTypes } from 'actions/types'

const INITIAL_STATE = null

function dataHandler(state, action) {
  return action.payload ? action.payload : INITIAL_STATE
}

const dataReducer = createReducer(INITIAL_STATE, {
  [requestedProductTypes.FETCH_REQUESTED_PRODUCT_FULFILLED]: dataHandler,
  [requestedProductTypes.CLEAR_FETCH_REQUESTED_PRODUCT]: dataHandler,
})

const reducer = combineReducers({
  requestState: requestStateReducer(requestedProductTypes.FETCH_REQUESTED_PRODUCT),
  data: dataReducer,
})

export default reducer
